import * as types from '../constants/ActionTypes';

const initialState = {
  loaded: false,
  available: false,
  waitTime: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_IDI_CONTACT_OPTIONS:
    case types.SELECT_TOPIC:
      return initialState;
    case types.UPDATE_LEXA_MESSAGE:
      return {
        ...state, available: action.payload.available, waitTime: action.payload.waitTime, loaded: true,
      };
    default:
      return state;
  }
}
